
import { Component, Prop, toNative, Vue } from 'vue-facing-decorator';
import useVuelidate from '@vuelidate/core';
import { required, minLength } from '@vuelidate/validators';
import { reactive } from 'vue';
import { ModalInputPopUpViewModel } from '@/entities/ModalInputPopUpViewModel';
import ModalInputType from '@/enums/ModalInputType';
import ValidationSummary from './ValidationSummary.vue';
@Component({
  components: {
    ValidationSummary,
  },
})
class ModalInputPopUp extends Vue {
  @Prop() private inputModal!: ModalInputPopUpViewModel;

  // local variable for handling data inside the modal
  private localInputModal: ModalInputPopUpViewModel = ModalInputPopUpViewModel.createEmpty();

  // cross icon
  private crossIcon = require('@/assets/Images/grey-cross-icon.svg');

  // Validation Summary flag
  private isValidationSummaryVisible = false;
  private validationErrorFields: string[] = [];

  // private message = '';
  private state = reactive({
    localInputModal: ModalInputPopUpViewModel.createEmpty(),
  });

  private rules = {
    localInputModal: {
      InputValue: {
        required,
        minLength: minLength(1),
      },
    },
  };
  private status(validation: { $error: any; $dirty: any }) {
    return {
      error: validation.$error,
      dirty: validation.$dirty,
    };
  }
  private v$ = useVuelidate(this.rules, this.state);

  // HTML input type derived from semantic InputType
  private get inputDataType(): string {
    switch (this.localInputModal.InputType) {
    case ModalInputType.Digits:
      return 'number';
    default:
      return 'text';
    }
  }

  // mounted method call
  private mounted(){
    this.localInputModal = structuredClone(this.inputModal);
    this.state.localInputModal = this.localInputModal;
  }

  // Block invalid keys in case of digits
  private BlockInvalidKeys(e: KeyboardEvent) {
    if (this.localInputModal.InputType !== ModalInputType.Digits) {
      return;
    }
    const invalidKeys = ['e', 'E', '+', '-', '.'];
    if (invalidKeys.includes(e.key)) {
      e.preventDefault();
    }
  }

  // Function to set MaxLength property for input type
  private MaxInputLength(){
    if((this.localInputModal.InputType === ModalInputType.Text)){
      return this.localInputModal.MaxValue;
    }
    return undefined;
  }

  private Cancel(): void {
    // close modal pop up and emit to parent component
    this.isValidationSummaryVisible = false;
    this.localInputModal.InputValue = '';
    this.$emit('close');
  }

  // Function closing validation summary
  private CloseValidationSummary(visible: boolean) {
    this.isValidationSummaryVisible = visible;
  }

  // Minimum value for digits
  private DigitsMinimumValue() {
    if (this.localInputModal.InputType === ModalInputType.Digits &&
      this.localInputModal.MinValue !== null &&
      this.localInputModal.MinValue !== undefined) {
      return this.localInputModal.MinValue;
    }
    return undefined;
  }

  // Maximum value for digits
  private DigitsMaximumValue() {
    if (this.localInputModal.InputType === ModalInputType.Digits &&
      this.localInputModal.MaxValue !== null &&
      this.localInputModal.MaxValue !== undefined) {
      return this.localInputModal.MaxValue;
    }
    return undefined;
  }

  private Send(val: any) {
    val.$touch();
    this.validationErrorFields = [];

    const rules = this.localInputModal.ValidationErrors || [];
    const value = (this.localInputModal.InputValue || '').toString();
    const inputType = this.localInputModal.InputType;

    for (const rule of rules) {
    // 1) "Required" rule (Regex === '')
      if (rule.Regex === '') {
        if (!value) {
          this.validationErrorFields.push(rule.ValidationMessage);
          this.isValidationSummaryVisible = true;
          return;
        }
        continue;
      }

      // 2) Digits: optionally do Min/Max check IF min/max configured
      if (inputType === ModalInputType.Digits) {
        const num = Number(value);
        const min = this.localInputModal.MinValue;
        const max = this.localInputModal.MaxValue;

        const hasMin = min !== null && min !== undefined;
        const hasMax = max !== null && max !== undefined;

        if (hasMin || hasMax) {
          const isNaNValue = Number.isNaN(num);
          const isBelowMin = hasMin && !isNaNValue && num < (min );
          const isAboveMax = hasMax && !isNaNValue && num > (max );

          if (isNaNValue || isBelowMin || isAboveMax) {
            this.validationErrorFields.push(rule.ValidationMessage);
            this.isValidationSummaryVisible = true;
            return;
          }
          continue;
        }
      }

      let pattern: RegExp;
      try {
        pattern = new RegExp(rule.Regex, 'i');
      } catch {
      // Invalid regex -> ignore this rule
        continue;
      }

      const isValid = pattern.test(value);

      if (!isValid) {
        this.validationErrorFields.push(rule.ValidationMessage);
        this.isValidationSummaryVisible = true;
        return;
      }
    }

    return this.$emit('submit', value);
  }
}
export default toNative(ModalInputPopUp);
